const gxjy = () => import('../../views/gxjy/index.vue');
const index = () => import('../../views/home/index.vue');
const zhaobiao = () => import('../../views/gxjy/zhaobiao.vue');
const zhaobiaoxq = () => import('../../views/gxjy/zhaobiaoxq.vue');
const allzhaobiao = () => import('../../views/gxjy/allzhaobiao.vue');
const allzhaobiaoxq = () => import('../../views/gxjy/allzhaobiaoxq.vue');
const caigouxq = () => import('../../views/gxjy/caigouxq.vue');
const caigou = () => import('../../views/gxjy/caigou.vue');
const kucun = () => import('../../views/gxjy/kucun.vue');
const zixun = () => import('../../views/gxjy/zixun.vue');
const kucunxq = () => import('../../views/gxjy/kucunxq.vue');
const allhuoke = () => import('../../views/gxjy/allhuoke.vue');
const jzcg = () => import('../../views/gxjy/jzcg.vue');
const jicailist = () => import('../../views/gxjy/jicailist.vue');
const fabujicai = () => import('../../views/gxjy/fabujicai.vue');
const xvqiuxq = () => import('../../views/gxjy/xvqiuxq.vue');
const lijibaoming = () => import('../../views/gxjy/lijibaoming.vue');
const baomingshuju = () => import('../../views/gxjy/baomingshuju.vue');
const daigong = () => import('../../views/gxjy/daigong.vue');
const daigonglist = () => import('../../views/gxjy/daigonglist.vue');
const daigongxq = () => import('../../views/gxjy/daigongxq.vue');
const baominglist = () => import('../../views/gxjy/baominglist.vue');
export default [ {
    
    path: '/index',
    name: 'index',
    component: index,
    children:[{
        path: '/gxjy',
        name: 'gxjy',
        component: gxjy,
    },
    {
        path: '/jzcg',
        name: 'jzcg',
        component: jzcg,
    },{
        path: '/jicailist',
        name: 'jicailist',
        component: jicailist,
    },{
        path: '/fabujicai',
        name: 'fabujicai',
        component: fabujicai,
    },{
        path: '/xvqiuxq',
        name: 'xvqiuxq',
        component: xvqiuxq,
    },{
        path: '/lijibaoming',
        name: 'lijibaoming',
        component: lijibaoming,
    },{
        path: '/baomingshuju',
        name: 'baomingshuju',
        component: baomingshuju,
    },{
        path: '/zhaobiao',
        name: 'zhaobiao',
        component: zhaobiao,
    },{
        path: '/zhaobiaoxq',
        name: 'zhaobiaoxq',
        component: zhaobiaoxq,
    },{
        path: '/allzhaobiao',
        name: 'allzhaobiao',
        component: allzhaobiao,
    },{
        path: '/allzhaobiaoxq',
        name: 'allzhaobiaoxq',
        component: allzhaobiaoxq,
    },
    {
        path: '/allhuoke',
        name: 'allhuoke',
        component: allhuoke,
    },{
        path: '/caigouxq',
        name: 'caigouxq',
        component: caigouxq,
    },{
        path: '/caigou',
        name: 'caigou',
        component: caigou,
    },{
        path: '/zixun',
        name: 'zixun',
        component: zixun,
    },{
        path: '/kucun',
        name: 'kucun',
        component: kucun,
    },{
        path: '/kucunxq',
        name: 'kucunxq',
        component: kucunxq,
    },{
            path: '/daigong',
            name: 'daigong',
            component: daigong,
        },{
            path: '/daigonglist',
            name: 'daigonglist',
            component: daigonglist,
        },{
            path: '/daigongxq',
            name: 'daigongxq',
            component: daigongxq,
        },{
            path: '/baominglist',
            name: 'baominglist',
            component: baominglist,
        }]
}
];
